import { VIEWS } from '../constants'

const viewsActions = {

    showEditSlideAnimationSettings() {
        return {
            type: VIEWS.SHOW_EDIT_SLIDE_ANIMATION_SETTINGS
        }
    },


    showEditSlideCaptionSettings() {
        return {
            type: VIEWS.SHOW_EDIT_SLIDE_CAPTION_SETTINGS
        }
    },

    showElementSettings() {
        return {
            type: VIEWS.SHOW_ELEMENT_SETTINGS
        }
    },

    showLinkSettings() {
        return {
            type: VIEWS.SHOW_LINK_SETTINGS
        }
    },

    showEditSlideSettings() {
        return {
            type: VIEWS.SHOW_EDIT_SLIDE_SETTINGS
        }
    },


    backToMainMenu() {
        return {
            type: VIEWS.SHOW_EDIT_SLIDE_DRILLDOWNS
        }
    },

    showLayers() {
        return {
            type: VIEWS.SHOW_LAYERS
        }
    },


}

export { viewsActions }